import { MSCalendar } from "../..";
import styles from "../styles.css";
import { IExclude } from "@lib/store/src/calendar";

import { ExceptionModal } from "./exception";
import { getEditExceptionTemplate } from "./edit-exception.templates";
import { UiFloatPopover } from "../../../common/popover";
import { popupEvent } from "../modal.templates";
import { EPeriodTypes } from "./exception.types";
import { formatExceptionText, initSelectOptions, sortExceptionsByPeriodType } from "./exception.helpers"; 
import i18next from "i18next";

/**
 * Редактирование исключение (расширение ExceptionModal class)
 * @class EditExceptionModal
 * @extends ExceptionModal
 * @classdesc EditExceptionModal
 * */
export class EditExceptionModal extends ExceptionModal {
  exceptionEdits: IExclude[]; // Исключение для редактирования
  exceptionsTest: {[key: string]: IExclude[]}
  exceptions: IExclude[];
  exceptionsSelect: HTMLSelectElement;
  filterButton: HTMLElement;
  filterDropdown: Element;
  filters: Array<EPeriodTypes> = [];

  constructor(rootID: string, root: MSCalendar) {
    super(rootID, root);
    super.init(getEditExceptionTemplate(), styles);
  }

  initVars() {
    const modal = this.popup.modalComponent;
    this.bodyEvents = modal.querySelector("#events");

    this.periodForm = modal.querySelector("#period-form");
    this.select = modal.querySelector("#select-period");
    this.priority = modal.querySelector("#priority"); 

    this.exceptionsSelect = this.popup.modalComponent.querySelector('#select-event-period');
    this.filterButton = this.popup.modalComponent.querySelector("#filter-button");
    this.filterDropdown = this.popup.modalComponent.querySelector("#filter-dropdown");
  }

  /**
   * Инициализация обработчиков событий
   */
  onStartup() {
    const modal = this.popup.modalComponent;

    modal.addEventListener("click", (e) => {
      const target = e.target as HTMLElement;

      // Обработка кнопки "Добавить"
      if (target.closest("#submit")) {
        this.submit();
      }

      // Обработка кнопки "Сбросить"
      if (target.closest("#reset")) {
        this.close();
      }

      // Обработка кнопки "Добавить событие"
      if (target.closest("#add-event")) {
        this.addEventTime();
      }
      
      // Обработка кнопки "Удалить событие"
      if (target.closest("#delete")) {
        this.showDeleteConfirmationPopup(e);
      }
    });

    this.bodyEvents?.addEventListener("click", (e) => this.onClickEvent(e));
    
    // Открытие/закрытие дропдауна
    this.filterButton.addEventListener('click', (e) => {
      e.stopPropagation();
      this.filterDropdown.classList.toggle('show');
    });
    
    // Закрытие дропдауна при клике вне его
    modal.addEventListener('click', () => {
      this.filterDropdown.classList.remove('show');
    });
    
    // Предотвращаем закрытие при клике внутри дропдауна
    this.filterDropdown.addEventListener('click', (e) => {
      e.stopPropagation(); 
    });

    this.filterDropdown.addEventListener('change', (e) => {
      if (e.target.matches('input[type="checkbox"]')) {
        const index = parseInt(e.target.name);
        
        if (e.target.checked) {
          if (!this.filters?.includes(index)) {
            this.filters?.push(index);
          }
        } else {
          const indexToRemove = this.filters?.indexOf(index);
          if (indexToRemove !== -1) {
            this.filters?.splice(indexToRemove, 1);
          }
        }
        
        // RERENDER
        this.resetForm();
        this.renderException()
      }
    });
  }

  /**
   * Обработчик кнопки сохранения нового расписания
   * */
  submit() {
    if (!this.isValidForm()) return;
    if (!this.isValidPeriodForm()) return;
  
    const period = this.selectHelper.getFormValues();
    const excludeEvents: Array<IExclude> = JSON.parse(
      JSON.stringify(this.root.store.excludeSchedule)
    );

    const exceptionEdits = []
    
    this.exceptionEdits.forEach(element => {
      const eventEdit = excludeEvents.find((x) => x.id === element?.id);
      if(eventEdit){
        exceptionEdits.push(eventEdit)
      }
    });

    if (this.eventsState.length > 0) {
      this.eventsState.forEach((event) => {
        const eventEdit = exceptionEdits.find((x) => x.id === event.id);
        if (eventEdit) {
          Object.assign(eventEdit, {
            ...eventEdit,
            ...event,
            period,
            priority: Number(this.priority.value),
          });
          
        } else {
          excludeEvents.push({
            ...event,
            period,
            priority: Number(this.priority.value),
          });
        }
      });

      this.store.onChange("excludeSchedule", excludeEvents);

      this.root.saveException();
    }

    this.close();
  }

  /**
   * Показ попапа подтверждения удаления
   * @param {MouseEvent} e MouseEvent
   * @param {HTMLElement} row Строка события
   *
   */
  showDeleteConfirmationPopup(e: MouseEvent, row?: HTMLElement) {
    setTimeout(() => {
      const popover = new UiFloatPopover(
        popupEvent({
          title: i18next.t($ => $.scheduleBacnet.deletion),
          desc: `${i18next.t($ => $.scheduleBacnet.areYouSureYouWantToDelete)}
            ${row ? i18next.t($ => $.scheduleBacnet.event).toLowerCase() : i18next.t($ => $.scheduleBacnet.exception).toLowerCase()}?`,
        }),
        {
          x: e.clientX,
          y: e.clientY,
        }
      );

      popover.root.querySelector("#primary")?.addEventListener("click", () => {
        if (row) {
          const exceptionEdit = this.exceptionEdits.find((x) => x.id === row.dataset.eventId );
          // Удаление конкретного события и очистка стора (включая новосозданных)
          if (exceptionEdit) {
            this.delete(exceptionEdit.id);
          }
          this.eventsState = this.eventsState.filter(x => x.id !== row.dataset.eventId);
          row.remove();
        } else {
          // Удаление целиком события и очистка стора (включая новосозданных)
          this.delete();
          this.eventsState = [];
        }
        
        if (this.eventsState.length === 0) {
          this.close();
        }
 
        popover.destroy();
        this.validateForms();
      });

      popover.root
        .querySelector("#secondary")
        ?.addEventListener("click", () => popover.destroy());
    }, 0);
  }

  delete(id?: string) {
    const excludeEvents: Array<IExclude> = JSON.parse(
      JSON.stringify(this.root.store.excludeSchedule)
    );

    let events
    if(id){
      events = excludeEvents.filter((x) => x.id !== id);
    } else {
      const ids = this.exceptionEdits.map(exception => exception.id)
      events = excludeEvents.filter((x) => !ids.includes(x.id))
    }
  
    this.store.onChange("excludeSchedule", events);

    this.root.saveException();
  }

  /**
   * Переключение видимости модального окна
   */
  toggle() {
    this.popup.modalComponent.toggle();
    if (!this.popup.modalComponent.active) return;
  }
  
  /**
   * Обновление селекта с списком всех исключений для выбранного Типа периода
   */
  updateExceptionsSelect(exceptions: string[]) {
    const values: [string, string][] = exceptions?.map(exception => 
      [exception, exception]
    );

    // Пересоздаем элемент (сброс всех слушателей)
    const newSelect = this.exceptionsSelect.cloneNode(true) as HTMLSelectElement;
    this.exceptionsSelect.replaceWith(newSelect);
    this.exceptionsSelect = newSelect;

    // По умолчанию выбираем первый элемент или пустоту (если массив пустой)
    initSelectOptions(this.exceptionsSelect, values?.at(0)?.at(0) ?? "", values);

    this.exceptionsSelect?.addEventListener("change", (e: Event) => {
      
      this.resetForm(); // сброс формы событий
      this.renderException(e.target.value ?? null); // Ре-рендер 
    });
  }

  sortByPeriodType(data: Array<IExclude>, selectedTypes: Array<EPeriodTypes> = []) {
    const filtered = selectedTypes.length > 0
    ? data.filter(item => selectedTypes.includes(item.period.type))
    : [...data];

    return filtered.sort((a, b) => a.period.type - b.period.type);
  }

  /**
   * Рендер формы исключения
   */
  renderException(exception?: string) {
    // Фильтр исключений по типу периода
    this.exceptions = sortExceptionsByPeriodType(this.exceptions, this.filters);

    this.exceptionsTest = {}
    for (let i = 0; i < this.exceptions.length; i++) {
      const element = this.exceptions[i];
      const periodtest = `${formatExceptionText(element?.period)}, ${element.priority}`
      if(this.exceptionsTest[periodtest]){
        this.exceptionsTest[periodtest].push(element)
      } else {
        this.exceptionsTest[periodtest] = [element]
      }
    }

    // Запоминаем исключение либо переданное для редактирования, либо первое из массива
    this.exceptionEdits =  this.exceptionsTest[exception] ?? Object.values(this.exceptionsTest)[0];
    const firstelem = this.exceptionEdits?.[0]
    if (this.exceptions.length && firstelem) {
      this.exceptionEdits.forEach((excludeEdit) => {
        // Заполнение данных о событии
        this.addEventTime({
          id: excludeEdit?.id,
          time: excludeEdit?.time,
          dataType: excludeEdit?.dataType,
          length: excludeEdit?.length,
          value: excludeEdit?.value,
        }); 
      })
    } else {
      this.exceptionEdits = []
    }

    // При первом рендере заполняем селект всех исключений
    if (!exception) {
      this.updateExceptionsSelect(Object.keys(this.exceptionsTest));
    }

    // Заполняем селект с типами периодов и подписываемся на изменение периода
    this.initPeriod(firstelem);

    // Установка приоритета
    this.priority.value = firstelem?.priority.toString() || "1";
  }

  /**
   * Сброс формы до начальных значений
   * Очистка хранилища данных и всех элементов из контейнера событий
   */
  resetForm() {
    this.eventsState = [];
    this.bodyEvents.innerHTML = "";
    this.periodForm.innerHTML = "";

    this.exceptions = JSON.parse(JSON.stringify(this.root.store.excludeSchedule));
  }

  /**
   * Открытие модального окна
   */
  open() {
    this.popup.modalComponent.open();

    this.resetForm();
    this.popup.uiModal.resetSize();

    this.renderException();  
  }

  /**
   * Закрытие модального окна
   */
  close() {
    this.popup.modalComponent.close();
  }
}
